import { useEffect, useState } from 'react';
import { Event } from 'nostr-tools';
import { getNostrPool } from '../lib/nostrPool';
import { RELAYS } from '../config/constants';

/**
 * NIP-23 Long-form Content Hook
 * Fetch articles/blogs from Nostr
 */
export const useLongFormContent = (limit: number = 10, turkishOnly: boolean = true) => {
    const [articles, setArticles] = useState<Event[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const pool = getNostrPool();

    useEffect(() => {
        setIsLoading(true);

        const filter = {
            kinds: [30023], // NIP-23 long-form content
            limit: limit * 2, // Fetch more to filter
        };

        const sub = pool.subscribeMany(RELAYS, filter, {
            onevent(event: Event) {
                // Filter for Turkish content if requested
                if (turkishOnly) {
                    const turkishWords = ['bir', 've', 'bu', 'için', 'ile', 'var', 'gibi', 'ama', 'çok'];
                    const contentLower = event.content.toLowerCase();
                    const hasTurkish = turkishWords.some(word => contentLower.includes(` ${word} `));
                    
                    if (!hasTurkish) return;
                }

                setArticles((prev) => {
                    const exists = prev.some((e) => e.id === event.id);
                    if (exists) return prev;
                    return [...prev, event]
                        .sort((a, b) => b.created_at - a.created_at)
                        .slice(0, limit);
                });
            },
            oneose() {
                setIsLoading(false);
            },
        });

        return () => sub.close();
    }, [limit, turkishOnly, pool]);

    return { articles, isLoading };
};
